import cronstrue from 'cronstrue';

angular
	.module('logbook')
	.directive('scheduler',['$timeout', '$q',
function($timeout, $q) {
	return {
		restrict: 'E',
		template: require('./scheduler.html'),
		
		scope: {
			onBind: '=',
			scheduleName: '=?',
			nameEnabled: '='
		},
		
		link: function(scope, elem)
		{

			scope.scheduleType = 'scheduler';
			scope.scheduleName = scope.scheduleName || scope.scheduleType;

			// Container for cells and controls types of cell available to be made
			scope.cells = {
				minutes: {
					displayName: 'Minutes',
					model: []
				},
				hours: {
					displayName: 'Hours',
					model: []
				},
				weekdays: {
					displayName: 'Weekdays',
					options: {
						showBadge: false,
						onlyOne: true,
						deleteable: false,
						static: true
					},
					model: []
				},
				monthdays: {
					displayName: 'Monthdays',
					model: []
				}
			};

			scope.cronDecorator = function(cron)
			{
				return cronstrue.toString(Object.values(cron).join(' ')) + ((cron.weekdays === '*' && cron.monthdays === '*') ? ', everyday' : '');
			};

			// Parsers for cell objects to cron
			// { type: { subType: function } }
			Object.assign(scope.cronConverters = {
					exact: function (settings)
					{
						return settings.value;
					},
					range: function (settings)
					{
						var toReturn = '';

						var start = (settings.startEnabled && settings.start != undefined && !isNaN(settings.start))
							? settings.start
							: 0;
						var end = (settings.endEnabled && settings.end != undefined && !isNaN(settings.end))
							? settings.end
							: 0;

						if (start === 0 && end === 0)
							toReturn = '*/';
						else
							toReturn = start + '-' + end + '/';

						toReturn += settings.interval;
						return toReturn;
					}
				},
				{
				minutes: {
					exact: scope.cronConverters.exact,
					range: scope.cronConverters.range
				},
				hours: {
					exact: scope.cronConverters.exact,
					range: scope.cronConverters.range
				},
				weekdays: {
					cronName: 'weekdays',
					exact: function(settings)
					{
						var days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
						var matches = Object.keys(settings)
							.filter(function(key)
							{
								return settings[key] === true
							})
							.map(function(key)
							{
								return days.findIndex(function(value) { return key === value })
							});
						return (matches.length) ? matches.join(',') : '*';
					}
				},
				monthdays: {
					exact: scope.cronConverters.exact,
					range: scope.cronConverters.range
				}
			});

			// Parsers for cron to cell objects
			// { type:{ subType: { options:{}, parser:function } || function } }
			Object.assign(scope.cronParsers = {

				// Sub-type level parsers
				exact: function(value, min, max)
				{
					var validationExp = /^\d+$/;
					var parsed = parseInt(value);
					if (value !== null && validationExp.test(value) && !isNaN(parsed) && parsed >= min && parsed <= max)
						return { subType: 'exact', result: { value: parsed } }
				},
				range: function(value, min, max)
				{
					var rangeValidation = /(((\d+-\d+)|(\d+)|(\*))\/\d+|(\d+-\d+))/g;
					var rangeMatcher = /(^\d+)|((?:(?!-)\d+))|(\d+$)/g;

					if (!rangeValidation.test(value)) return;

					var result = {  };
					if (!value.includes('*'))
					{
						var parsed = value.match(rangeMatcher).map(function(value) { return parseInt(value); });
						if (parsed.length > 1)
						{
							var start = parsed[0];
							var end = parsed[1];

							result.start = (start >= min) ? start : min;
							result.end = (end <= max) ? end : max;
							result.interval = (parsed.length >= 3) ? parsed[2] : 1;
						}
					}
					else
					{
						var intervalMatcher = /(?:(?!\/)\d+$)/;
						var matched = value.match(intervalMatcher);
						result.start = min;
						result.end = max;
						result.interval = (matched.length === 1 && !isNaN(parseInt(matched[0])))
										? parseInt(matched[0])
										: 1;
					}
					return { subType: 'range', result: result };
				}
			},
			{
				// Type level parsers
				minutes: {
					exact: function(value) { return scope.cronParsers.exact(value, 0, 59) },
					range: function(value) { return scope.cronParsers.range(value, 0, 59) }
				},
				hours: {
					exact: function(value) { return scope.cronParsers.exact(value, 0, 23) },
					range: function(value) { return scope.cronParsers.range(value, 0, 23) }
				},
				weekdays: {
					exact: {
						options: {
							takesAll: true
						},
						parser: function(value)
						{
							var rangeMatcher = /(^\d+)|((?:(?!-)\d+))|(\d+$)/g;
							var toReturn = {
								subType: 'exact',
								result: {
									Sun: false,
									Mon: false,
									Tues: false,
									Wed: false,
									Thurs: false,
									Fri: false,
									Sat: false
								}
							};
							var keys = Object.keys(toReturn.result);
							if (Array.isArray(value) && rangeMatcher.test(value[0]))
							{
								var resultGroups = value[0].match(rangeMatcher);
								if (resultGroups.length === 2)
									for (var i = parseInt(resultGroups[0]); i <= parseInt(resultGroups[1]); i++)
									{
										value.push(i);
									}
							}

							if (!Array.isArray(value) ||
								!(value = value.filter(function(index)
								{
									return !isNaN(parseInt(index)) && index !== null && (index >= 0 && index < keys.length)
								})).length)
								return;

							value.forEach(function(index)
							{
								toReturn.result[keys[index]] = true;
							});

							return toReturn;
						}
					}
				},
				monthdays: {
					exact: function(value) { return scope.cronParsers.exact(value, 1, 31) },
					range: function(value) { return scope.cronParsers.range(value, 1, 31) }
				}
			});

			setupSchedulerScope(scope, elem, $timeout, $q);

			/**
			 * Callback called when a new cell is created.
			 * @param cell - The created cell
			 */
			scope.onCellBind = function(cell)
			{
				cell.addOnDeleteEvent(function(cellScope, e)
				{
					var index = scope.cells[cellScope.type].model.findIndex(function(cellObj)
					{
						return cellObj === cellScope.cellObj;
					});

					if (index >= 0)
					{
						scope.cells[cellScope.type].model.splice(index, 1);
						$timeout(function ()
						{
							scope.updateAdvancedInput();
							scope.setAddCellBtnState(cellScope.type, !(scope.cells[cellScope.type].model.length >= scope.cells[cellScope.type].maxItems));
						});
					}

					scope.onChange();
				});

				cell.addOnChangeEvent(function(model, typing, event)
				{
					scope.updateAdvancedInput();
					scope.onChange();
				})
			};

			if (typeof scope.onBind === 'function')
				scope.onBind(scope);

			/**
			 * Updates Advanced cron-spec inputs with the results of the parsed items from the cell model
			 */
			scope.updateAdvancedInput = function()
			{
				var cron = scope.getConverterResult().cron;
				Object.keys(cron).forEach(function(key)
				{
					$(elem).find('#input-cron-' + key).val(cron[key]);
				});

				var output = cronstrue.toString(Object.keys(cron)
					.map(function(cronKey)
					{
						return cron[cronKey];
					})
					.join(' '));

				if (cron.weekdays === '*' && cron.monthdays === '*') output += ', everyday';
				$(elem).find('#heading-readable-output').html(output);
			};

			/**
			 * Clears all cell containers and sets their contents to be the parsed cells created from advanced input
			 */
			scope.createFromAdvancedInput = function()
			{
				scope.holdOnChange = true;
				function mapModel(cellModel, type, subType)
				{
					var model = {};
					model[type] = {};
					model[type][subType] = cellModel;

					return {
						type: type,
						subType: subType,
						model: model,
						options: scope.getTypeOptions(type),
						$selector: scope.getContainerSelector(type)
					};
				}

				Object.keys(scope.cells).forEach(function (key)
				{
					var $selector = $(elem).find('[spec-type=' + key + ']');
					scope.cells[key].model.length = 0;
					scope.setAddCellBtnState(key, true);

					if ($selector.length <= 0 || !scope.cronParsers[key]) return;

					var values = $selector.val().split(',');

					Object.keys(scope.cronParsers[key]).forEach(function(parserKey)
					{
						var parser = scope.cronParsers[key][parserKey];

						// Process Parser Options
						if (typeof parser === 'object' && parser !== null)
						{
							var options = parser.options;
							parser = parser.parser;

							if (typeof parser !== 'function') return;

							if (options.takesAll === true)
							{
								values = [values.reduce(function(array, currentVal)
								{
									array.push(currentVal);
									return array;
								}, [])]
							}
						}

						if (typeof parser === 'function')
						{
							values = values.map(function (value)
							{
								var result = parser(value);
								if (typeof result === 'undefined' || typeof result.result !== 'object') return value;

								return mapModel(result.result, key, parserKey)
							})
						}
					});
					values = values.filter(function(cellObj) { return typeof cellObj !== 'string' && !Array.isArray(cellObj)});

					if (values.length === 0) $selector.val('*');
					values.forEach(function(cellObj)
					{
						scope.addCustomCell(cellObj);
					})
				});
				scope.applySettings();
			};

			scope.updateAdvancedInput();
			scope.holdOnChange = false;
		}
	}
}]);

/**
 * Sets up base configuration for a scheduler scope
 */
export function setupSchedulerScope(scope, elem, $timeout, $q)
{
	scope.errorMsg = '';
	scope.onDeleteEvents = [];


	/**
	 * Gets the types the belong to the scope model
	 * @returns {string[]}
	 */
	scope.getModelTypes = function()
	{
		return (typeof scope.cells !== 'object')
				? []
				: Object.keys(scope.cells);
	};

	/**
	 * Executes a function across all cells
	 * @param {function(modelType: {string}, cellObj: {}, index: {number})} toExec
	 */
	scope.forEachCell = function(toExec)
	{
		scope.getModelTypes().forEach(function(key)
		{
			scope.cells[key].model.forEach(function(cellObj, index)
			{
				toExec(key, cellObj, index);
			})
		});
	};


	/**
	 * Applies a mapping function to each cell
	 * @param {function(cellObj:{}, index:{number})} mapFunc - Function used to map each cellObj
	 */
	scope.mapCells = function(mapFunc)
	{
		return scope.getModelTypes().reduce(function(mappedObj, cellKey)
		{
			mappedObj[cellKey] = scope.cells[cellKey].model.map(mapFunc);
			return mappedObj;
		}, {})
	};

	/**
	 * Gets the cell container selector for the specified type
	 * @param {string} forType - Cell model type to get container for
	 * @returns {HTMLElement | * | jQuery | HTMLElement}
	 */
	scope.getContainerSelector = function(forType)
	{
		return $('[cell-container-type=' + forType + ']');
	};

	/**
	 * Creates a cell of the specified type and adds it to the cell model.
	 * The cell will be set to the first of its sub-types.
	 *
	 * @param {string} type - Type of cell to be created
	 * @param {{}} options - Additional Options to send to cell
	 */
	scope.addCell = function(type, options)
	{
		if (!scope.getModelTypes().includes(type)) return;

		var $selector = scope.getContainerSelector(type);
		options = (typeof options === 'object')
			? options
			: scope.getTypeOptions(type);

		scope.cells[type].model.push({ type: type, $selector: $selector, options: options || {} });
		scope.setAddCellBtnState(type, (!(scope.cells[type].model.length >= scope.cells[type].maxItems)));
		
		if (!options.suppressOnChange)
			scope.onChange();
	};

	/**
	 * Adds an already made cell object to the cell model
	 * @param {{ type:string, subType: string }} cellObj - Cell Object to add
	 * @param {boolean} suppressOnChange - Whether to not fire onChange event
	 */
	scope.addCustomCell = function(cellObj, suppressOnChange)
	{
		if (!cellObj.hasOwnProperty('type')) return;

		var cellArr = scope.cells[cellObj.type].model;
		if (Array.isArray(cellArr))
		{
			cellArr.push(cellObj);
			scope.setAddCellBtnState(cellObj.type, !(cellArr.length >= scope.cells[cellObj.type].maxItems))
			
			if (!suppressOnChange)
				scope.onChange();
		}
	};

	/**
	 * Sets the state of the specified type's add cell button
	 * @param {string} forType - Container Main-Type of the button
	 * @param {boolean} enabled - The enabled state of the button
	 */
	scope.setAddCellBtnState = function(forType, enabled)
	{
		$(elem)
			.find('[add-btn-type=' + forType + ']')
			.toggleClass('values-disabled', !enabled)
	};

	/**
	 * Sets the visibility of the specified type's add cell button
	 * @param {string} forType - Container Main-Type of the button
	 * @param {boolean} visible - The visible state of the button
	 */
	scope.setAddCellBtnVisibility = function(forType, visible)
	{
		var button = $(elem)
			.find('[add-btn-type=' + forType + ']')
			.toggleClass('hidden', !visible)
	};

	/**
	 * Sets the badge visibility for a type's tab
	 * @param {string} forType - type from cells model
	 * @param {boolean} visible - The visible state of the badge
	 */
	scope.setBadgeVisibility = function(forType, visible)
	{
		$(elem).find('[badge-for-type=' + forType + ']').toggleClass('hidden', !visible);
	};

	scope.addBtnClick = function(e)
	{
		var type = $(e.target).attr('add-btn-type');

		if (type && Object.keys(scope.cells).includes(type))
			scope.addCell(type);
	};

	/**
	 * Retrieves the options object belonging to a cell type
	 * @param {string} type - Type of cell
	 * @returns {*}
	 */
	scope.getTypeOptions = function(type)
	{
		return (!scope.getModelTypes().includes(type) || typeof scope.cells[type].options !== 'object')
			? {}
			: scope.cells[type].options;
	};

	/**
	 * Applies settings that apply to the UI from the cells model
	 */
	scope.applySettings = function(suppressOnChange)
	{
		return $timeout(function()
		{
			scope.getModelTypes().forEach(function(key)
			{
				let options = scope.getTypeOptions(key);
				options.suppressOnChange = !!suppressOnChange;
				
				if (options.static && scope.cells[key].model.length < 1)
						scope.addCell(key, options);

				if (typeof options.showBadge === 'boolean')
					scope.setBadgeVisibility(key, options.showBadge);

				scope.setAddCellBtnVisibility(key, (typeof options.onlyOne === 'boolean') ? !options.onlyOne : true);
			});

		});
	};

	/**
	 * Changes the scheduler name
	 * @param {string} newName - New name for scheduler
	 */
	scope.changeName = function(newName)
	{
		if (typeof newName === 'string' && newName.length)
			scope.scheduleName = newName;
	};

	/**
	 * Processes scope.cronConverters and returns the result
	 * @return {{cron: {hours: string, month: string, minutes: string, weekdays: string, monthdays: string}, decorated: (*|string)}}
	 */
	scope.getConverterResult = function()
	{
		if (!scope.cronConverters) return;
		var cronSpec = {
			minutes: '*',
			hours: '*',
			monthdays: '*',
			month: '*',
			weekdays: '*'
		};
		var specKeys = Object.keys(cronSpec);

		var obj = scope.mapCells(function(cellObj, index)
		{
			if (typeof cellObj.type !== 'string' ||  typeof cellObj.subType !== 'string')
				return;

			var settings = JSON.parse(JSON.stringify(cellObj.model[cellObj.type][cellObj.subType]));
			return scope.cronConverters[cellObj.type][cellObj.subType](settings);
		});
		Object.keys(obj).forEach(function(key)
		{
			var specKey = scope.cronConverters[key].cronName || key;
			if (!specKeys.includes(specKey)) return;

			var result = (Array.isArray(obj[key]) && obj[key].length > 0 && obj[key][0] != undefined)
						? obj[key].join(',')
						: (cronSpec[specKey] === '*') ? '*' : '';

			if (result === '')
				return;
			else if (cronSpec[specKey] !== '*')
				cronSpec[specKey] += ',' + result;
			else
				cronSpec[specKey] = result;
		});
		return {
			cron: cronSpec,
			decorated: (typeof scope.cronDecorator === 'function')
				? scope.cronDecorator(cronSpec)
				: Object.values(cronSpec).join(' ')
		} ;
	};

	/**
	 *  Sets the scheduler from the provided cron object. Uses the scheduler's cronParsers.
	 * @param {{minutes: string, hours: string, monthdays: string, month: string, weekdays: string}} cron
	 * @return {Promise<Object>} Scheduler Scope
	 */
	scope.fromCronInput = function(cron)
	{
		scope.forEachCell(function(name, cell, index)
		{
			cell.deleteCell();
		});

		function mapModel(cellModel, type, subType)
		{
			var model = {};
			model[type] = {};
			model[type][subType] = cellModel;

			return {
				type: type,
				subType: subType,
				model: model,
				suppressOnChange: true,
				options: {...scope.getTypeOptions(type), suppressOnChange: true},
				$selector: scope.getContainerSelector(type)
			};
		}

		return $timeout(function()
			{
				Object.keys(cron).forEach(function(parserType)
				{
					var toAdd = {
						type: parserType,
						cellModels: []
					};

					if (scope.cronParsers[parserType] == undefined || !scope.cells[parserType]) return;

					Object.values(scope.cronParsers[parserType]).forEach(function(parser, index)
					{
						var cronArr = cron[parserType].split(',');
						if (typeof parser === 'object' && parser.options)
						{
							if (parser.options.takesAll)
								cronArr = [cronArr.reduce(function(arr, current){ arr.push(current); return arr; }, [])];

							parser = parser.parser;
						}

						cronArr.forEach(function(cronStr)
						{
							if (typeof parser === 'function')
							{
								var cellModel = parser(cronStr);
								if (typeof cellModel === 'object')
									toAdd.cellModels.push(mapModel(cellModel.result, parserType, Object.keys(scope.cronParsers[parserType])[index]));
							}
						});

					});

					scope.cells[parserType].model.length = 0;
					toAdd.cellModels.forEach(function(cellObj) { return scope.addCustomCell(cellObj, true) })
				});
			})
			.then(function()
			{
				return $q(function(resolve)
				{
					scope.applySettings(true)
						.finally(() => {
							if (typeof scope.updateAdvancedInput === 'function')
								scope.updateAdvancedInput();
							else if (typeof scope.updateCronOutput === 'function')
								scope.updateCronOutput();
							
							resolve(scope);
						});
				})
			});

	};


	scope.onChangeEvents = [];
	scope.addOnChangeEvent = function(callback)
	{
		if (typeof callback === 'function') scope.onChangeEvents.push(callback);
	};

	scope.onChange = function()
	{
		scope.onChangeEvents.forEach(function(callback)
		{
			if (typeof callback === 'function') callback(scope);
		})
	};

	/**
	 * Adds a function to be called when the scheduler is deleted
	 * @param {function} func
	 */
	scope.addOnDeleteEvent = function(func)
	{
		if (typeof func === 'function')
			scope.onDeleteEvents.push(func)
	};

	/**
	 * Deletes the scheduler and calls all set onDelete events for itself and its child cells
	 */
	scope.onDelete = function()
	{
		scope.onDeleteEvents.forEach(function(func)
		{
			if (typeof func === 'function')
				func(scope);
		});
		scope.forEachCell(function(cell, cellObj)
		{
			cellObj.delete();
		});
		scope.$emit('schedulerDestroyed', scope);
		scope.$destroy();
	};

	/**
	 * Deletes the scheduler and calls all set onDelete events for itself and its child cells
	 */
	scope.delete = scope.onDelete;

	/**
	 * Gets the value of #input-name and submits it to the schedule name update method
	 */
	scope.submitNameFromInput = function()
	{
		$timeout(function()
		{
			scope.changeName($(elem).find('#input-name').val());
			scope.toggleEditName(false);
		});
	};
	
	/**
	 * Determines whether all cells are empty
	 * @return {Boolean}
	 */
	scope.isEmpty = function()
	{
		return Object.values(scope.cells).every(function(model){ return !model.model.length })
	}

	/**
	 * Collapses the panel body of the schedule cell.
	 * @param {boolean=} shouldCollapse - Whether the panel should be collapsed. If not provided the option toggles from the current.
	 */
	scope.collapseBody = function(shouldCollapse)
	{
		var command = (typeof shouldCollapse === 'boolean')
			? (shouldCollapse) ? 'hide' : 'show'
			: 'toggle';

		var collapseElem = $(elem).find('#schedule-collapse-body').collapse(command);
	};

	/**
	 * Collapses the advance panel of the scheduler
	 * @param {boolean=} shouldCollapse - Whether the panel should be collapsed. If not provided the option toggles from the current.
	 */
	scope.collapseAdvancePanel = function(shouldCollapse)
	{
		var command = (typeof shouldCollapse === 'boolean')
			? (shouldCollapse) ? 'hide' : 'show'
			: 'toggle';

		$(elem).find('#advance-panel').collapse(command);
	};

	/**
	 * Hides/shows the delete confirmation screen on the scheduler header
	 * @param {boolean} isDeleting - State of showing the header
	 */
	scope.toggleDeleteScreen = function(isDeleting)
	{
		$(elem).find('#schedule-panel').toggleClass('panel-primary', !isDeleting);
		$(elem).find('#schedule-panel').toggleClass('panel-default', isDeleting);

		$(elem).find('#scheduler-ask-to-delete').toggleClass('hidden', !isDeleting);
		$(elem).find('#scheduler-default-panel').toggleClass('hidden', isDeleting);
		$(elem).find('#schedule-body').toggleClass('values-disabled', isDeleting);
	};

	/**
	 * Hides/shows the edit name screen on the scheduler header
	 * @param {boolean} isEditing - State of showing the header
	 */
	scope.toggleEditName = function(isEditing)
	{
		$(elem).find('#schedule-panel').toggleClass('panel-primary', !isEditing);
		$(elem).find('#schedule-panel').toggleClass('panel-default', isEditing);

		$(elem).find('#scheduler-edit-name').toggleClass('hidden', !isEditing);
		$(elem).find('#scheduler-default-panel').toggleClass('hidden', isEditing);
		$(elem).find('#schedule-body').toggleClass('values-disabled', isEditing);

		$(elem).find('#input-name').val(scope.scheduleName);
	};

	// Stops collapse event from going up to other collapse events
	$(elem).find('#advance-panel')
		.on('shown.bs.collapse', function(event)
		{
			event.stopPropagation();
		})
		.on('hidden.bs.collapse', function(event)
		{
			event.stopPropagation();
		});

	// Sets trigger for when the body collapses to change the dropdown toggle chevron
	$(elem).find('#schedule-collapse-body')
		.on('shown.bs.collapse', function(event)
		{
			$(elem).find('#btn-collapse')
				.toggleClass('active', true);

			event.stopPropagation();
		})
		.on('hidden.bs.collapse', function(event)
		{
			$(elem).find('#btn-collapse')
				.toggleClass('active', false);

			event.stopPropagation();
		});

	scope.applySettings(true);

	scope.$emit('schedulerCreated', scope);

	scope.$on('destroyScope', function()
	{
		scope.delete();
	});

	scope.$on('cellCreated', function(event, cellScope)
	{
		event.stopPropagation();
		if (scope.timeout)
			window.clearTimeout(scope.timeout);

		if (cellScope && cellScope.cellObj && cellScope.cellObj.options && cellScope.cellObj.options.suppressOnChange)
			return;
		
		scope.timeout = window.setTimeout(scope.onChange, 200);
	});
}